import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Heart, ChevronDown } from 'lucide-react';

const RSVPCallToAction = () => {
  const { t, isBangla, hasSelectedLanguage } = useLanguage();

  const scrollToRSVP = () => {
    const rsvpSection = document.getElementById('rsvp');
    if (rsvpSection) {
      rsvpSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!hasSelectedLanguage) return null;

  return (
    <section className="py-8 sm:py-10 px-4 bg-gradient-to-b from-[#FFF8F0] to-[#F5E6D3]">
      <div className="max-w-lg mx-auto">
        <motion.div
          className="relative overflow-hidden bg-gradient-to-br from-[#800020] to-[#600018] rounded-2xl p-6 sm:p-8 shadow-2xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Decorative background pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#D4AF37] rounded-full -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#D4AF37] rounded-full translate-y-1/2 -translate-x-1/2" />
          </div>

          <div className="relative z-10 text-center">
            {/* Heart icon */}
            <motion.div
              className="w-12 h-12 sm:w-14 sm:h-14 mx-auto mb-4 bg-[#D4AF37]/20 rounded-full flex items-center justify-center"
              animate={{ scale: [1, 1.1, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <Heart className="w-6 h-6 sm:w-7 sm:h-7 text-[#D4AF37] fill-[#D4AF37]" />
            </motion.div>

            {/* Subtext */}
            <p className={`text-white/80 text-sm sm:text-base mb-4 ${isBangla ? 'font-bangla' : ''}`}>
              {t('rsvpCtaSubtext')}
            </p>

            {/* Main CTA Button */}
            <motion.button
              onClick={scrollToRSVP}
              className={`
                px-10 sm:px-12 py-4 sm:py-5
                bg-[#D4AF37] hover:bg-[#C4A030]
                text-[#2D2424] font-bold text-lg sm:text-xl
                rounded-xl shadow-lg hover:shadow-xl
                transition-all duration-300
                flex items-center justify-center gap-3 mx-auto
                ${isBangla ? 'font-bangla' : ''}
              `}
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              data-testid="rsvp-cta-button"
            >
              {t('rsvpCta')}
              <ChevronDown className="w-5 h-5 sm:w-6 sm:h-6 animate-bounce" />
            </motion.button>

            {/* RSVP deadline reminder */}
            <p className={`text-[#D4AF37]/80 text-xs sm:text-sm mt-4 ${isBangla ? 'font-bangla' : ''}`}>
              {t('rsvpByDate')}
            </p>
          </div>

          {/* Gold border accent */}
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
        </motion.div>
      </div>
    </section>
  );
};

export default RSVPCallToAction;
